import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';

function RightAds() {   
    var RightADV = ""; 

    const desktop_right = useSelector((state) => state.HomeBucket.bucket.data.ads.desktop_right);
    const dispatch = useDispatch();

    function openModal() {
       dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:desktop_right.popupname}));
    }

    if(desktop_right.popupname){
        RightADV = () => <div dangerouslySetInnerHTML={{__html: desktop_right.data}} />
        //RightADV = () => <button onClick={() => openModal()}><div dangerouslySetInnerHTML={{__html: desktop_right.data}} /></button>
     }else{
        RightADV = () => <div dangerouslySetInnerHTML={{__html: desktop_right.data}} />
     }

    /******get data from localstorage*******/
    let authlogin = localStorage.getItem('authlogin');
    let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";
    var initialUsername = storageDataAuthLogin ? storageDataAuthLogin.user_email :  "";

  if(initialUsername==="vip@ciisummit.com" || initialUsername==="VIP@CIISUMMIT.COM"){
    RightADV = () => <div><img src="https://community-wp.ciisummit.com/wp-content/uploads/2023/02/ciis-webnar-series.jpg"></img></div>
  }

    return (
    <>
    <div className="right-ads-section desktop-screen-show">
       
        <RightADV />

    </div>
    
    </>
    );
}

export default RightAds;